module.exports = __webpack_public_path__ + "static/media/l_dot_12.a6b54d4c.png";